import { Page } from "@betomorrow/micro-stores"
import { BenchmarkTypeOf } from "@modules/benchmark/benchmarkTypes"
import { BoxTypeOf } from "@modules/box/boxTypes"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { ExploreContentType } from "@modules/explore/exploreTypes"
import { ExploreApiGateway } from "@modules/explore/gateway/exploreApiGateway"
import {
  ExploreBenchmarkContentDtoSchema,
  ExploreBoxContentDtoSchema,
  ExploreContentDto,
  ExploreProfileContentDtoSchema,
  ExploreProgamContentDtoSchema,
  ExploreProgramBundleContentDtoSchema,
} from "@modules/explore/gateway/exploreDto"
import { ProfileTypeOf } from "@modules/profile/profileTypes"
import { ProgramBundleTypeOf } from "@modules/programBundle/api/programBundleDto"
import { ProgramContentTypeOf } from "@modules/programs/programTypes"
import { Paginated, toPage } from "@modules/utils/paginated"
import { compact } from "lodash"

export class ExploreApi implements ExploreApiGateway {
  private baseUrl = "/explore"

  constructor(private api: ApiClient) {}

  async searchExplore(
    query: string | undefined,
    options?: {
      filter?: ExploreContentType
      page?: number
      size?: number
    },
  ): Promise<Page<ExploreContentDto>> {
    const result = await this.api.get<Paginated<ExploreContentDto>>(`${this.baseUrl}`, {
      params: {
        query,
        page: options?.page ?? 0,
        size: options?.size ?? 24,
        filter: options?.filter,
      },
    })
    const pageResult = toPage(result.data)

    return {
      ...pageResult,
      content: compact(
        pageResult.content.flatMap((content) => {
          if (content.contentType === BenchmarkTypeOf) {
            return ExploreBenchmarkContentDtoSchema.parse(content)
          }
          if (content.contentType === ProgramContentTypeOf) {
            return ExploreProgamContentDtoSchema.parse(content)
          }
          if (content.contentType === ProgramBundleTypeOf) {
            return ExploreProgramBundleContentDtoSchema.parse(content)
          }
          if (content.contentType === BoxTypeOf) {
            return ExploreBoxContentDtoSchema.parse(content)
          }
          if (content.contentType === ProfileTypeOf) {
            return ExploreProfileContentDtoSchema.parse(content)
          }
        }),
      ),
    }
  }
}
